import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import ShowSummaryComponent from "./ShowSummaryComponent";
import {X, Book} from "react-feather";




function ShowSummaryModalComponent(props) {

    const [modalShow, setModalShow] = React.useState(false);
    const annotationData = props.annotationData
    const setAnnotationData = props.setAnnotationData
    let [lvid] = useState(props.lvid)

    console.log(typeof props.setAnnotationData, "modal")

    function ShowSummaryModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Summary
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowSummaryComponent lvid={props.lvid} annotationData={annotationData}
							setAnnotationData={setAnnotationData}/>
                </Modal.Body>
                <Modal.Footer>
                   <Button size="lg" variant="outline-dark" onClick={props.onHide}> <X/> &nbsp;
                        Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    return (

        <>
            <Button className="handwai-btn-password-reset" onClick={() => setModalShow(true)}><Book /> Summary</Button>
            <ShowSummaryModal
                lvid={lvid}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>

    );
}

export default ShowSummaryModalComponent;
